// import Raven from 'raven-js';

import Firebase from "@/services/Firebase";
import options from "@/options";

export default {
  namespaced: true,
  state: {
    evaluationInTitle: true,
    incognitoMode: false,
    nightMode: false,
    bannerStatus: true,
    lang: document.documentElement.getAttribute("lang") || options.defaultLang,
    currency: options.defaultCurrency,
    sortBy: options.defaultSortBy,
    sortByDir: true, // true - asc, false - desc
    assetsTableExchId: -1, // all
    showValuationsPerExchange: true,
    profitlossMode: false,
  },
  getters: {
    evaluationInTitle: (state) => state.evaluationInTitle,
    incognitoMode: (state) => state.incognitoMode,
    nightMode: (state) => state.nightMode,
    lang: (state) =>
      options.languages.findIndex((v) => state.lang == v.language) > -1
        ? state.lang
        : options.defaultLang,
    currency: (state) =>
      options.currencies.findIndex((v) => state.currency == v.symbol) > -1
        ? state.currency
        : options.defaultCurrency,
    sortByColumns: (state) =>
      state.profitlossMode
        ? options.sortByColumns_profitloss
        : options.sortByColumns,
    sortBy: (state, getter) =>
      getter.sortByColumns.findIndex((v) => state.sortBy == v.name) > -1
        ? state.sortBy
        : options.defaultSortBy,
    sortByObj: (state, getter) =>
      getter.sortByColumns.find((v) => state.sortBy == v.name) ||
      getter.sortByColumns[0],
    sortByDir: (state) => state.sortByDir,
    sortByDirTxt: (state) => (state.sortByDir ? "asc" : "desc"),
    assetsTableExchId: (state) => state.assetsTableExchId,
    showValuationsPerExchange: (state) => state.showValuationsPerExchange,
    profitlossMode: (state) => state.profitlossMode,
  },
  mutations: {
    setSetting(state, { setting, value }) {
      state[setting] = value;
    },
    toggleSetting(state, setting) {
      state[setting] = !state[setting];
    },
  },
  actions: {
    setSetting: ({ state, commit }, { setting, value }) => {
      if (typeof state[setting] === "undefined") {
        return;
      }
      commit("setSetting", { setting, value });
    },
    setCurrency: ({ commit, dispatch, rootGetters }, { currency, source }) => {
      if (source === "firebase") {
        commit("setSetting", { setting: "currency", value: currency });
      } else if (rootGetters["auth/isLoggedIn"]) {
        Firebase.saveCurrency(currency);
      } else {
        commit("setSetting", { setting: "currency", value: currency });
      }
    },
    toggleSetting: ({ state, commit }, setting) => {
      if (typeof state[setting] === "undefined") {
        return;
      }
      commit("toggleSetting", setting);
    },
  },
};
